<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{ edit ? `Edit User` : "Add User" }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model.trim="form.first_name"
              label="First Name*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>
          <v-col cols="6">
            <v-text-field
              v-model.trim="form.last_name"
              label="Last Name*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>
          <v-col cols="6">
            <v-text-field
              v-model.trim="form.email"
              label="Email*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required, rules.email]"
          /></v-col>
          <v-col cols="6">
            <v-text-field
              v-model.trim="form.mobile_no"
              label="Mobile Number*"
              outlined
              dense
              maxlength="10"
              hide-details="auto"
              :rules="[rules.required, rules.mobile]"
          /></v-col>
          <v-col cols="6">
            <v-select
              v-model="form.partner_id"
              :items="partners"
              item-text="name"
              item-value="id"
              label="Partner*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
            />
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="form.role_id"
              :items="roles"
              item-text="name"
              item-value="id"
              label="Role*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.password"
              :label="edit ? 'New Password' : 'Password*'"
              :hint="
                edit ? 'Leave blank to keep the current password' : ''
              "
              persistent-hint
              outlined
              dense
              hide-details="auto"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showPassword = !showPassword"
              :rules="passwordRules"
          /></v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">{{
          edit ? "Update" : "Save"
        }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
    partners: {
      type: Array,
      default: () => [],
    },
    roles: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {
      rules,
      form: {},
      showPassword: false,
    };
  },
  computed: {
    passwordRules() {
      return this.edit
        ? [(v) => !v || rules.password(v)]
        : [rules.required, rules.password];
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      if (this.edit) {
        this.form = { ...this.user, password: "" };
      }
    },

    save() {
      if (!this.$refs.form.validate()) return;

      const payload = { ...this.form };
      if (this.edit && !payload.password) {
        delete payload.password;
      }

      if (this.edit) {
        this.$emit("update", payload);
      } else {
        payload.active = true;
        this.$emit("create", payload);
      }
    },
  },
};
</script>

<style scoped></style>
